module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Seasonal-c3402226b6fbe43f8480b9cec603c8a1.png";